var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFooter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 422,
    viewBox: "0 0 1512 422",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_98_4",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1512,
    height: 422
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 422,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_98_4)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M440.039 100.83C287.723 -27.5875 14.9415 71.198 -13.3517 88.8613C-85.9865 164.485 -227.351 340.638 -211.732 440.263C-192.209 564.795 -55.808 564.652 165.273 625.646C386.355 686.64 559.203 763.449 831.063 808.489C1102.92 853.528 1562.11 737.019 1575 696.437C1587.89 655.856 1641.56 221.578 1483.65 118.119C1325.73 14.6596 1208.46 78.6638 972.253 151.376C736.042 224.088 592.355 229.247 440.039 100.83Z",
    fill: "url(#paint0_linear_98_4)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M409.256 158.279C256.94 29.8617 -15.8414 128.647 -44.1347 146.311C-116.769 221.934 -258.134 398.087 -242.515 497.712C-222.992 622.244 -86.5909 622.101 134.49 683.095C355.572 744.09 528.42 820.899 800.28 865.938C1072.14 910.978 1531.32 794.468 1544.21 753.886C1557.1 713.305 1610.78 279.027 1452.87 175.568C1294.95 72.1088 1177.68 136.113 941.47 208.825C705.259 281.537 561.572 286.696 409.256 158.279Z",
    fill: "url(#paint1_linear_98_4)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M437.256 257.279C284.94 128.862 12.1586 227.647 -16.1347 245.311C-88.7695 320.934 -230.134 497.087 -214.515 596.712C-194.992 721.244 -58.5909 721.101 162.49 782.095C383.572 843.09 556.42 919.899 828.28 964.938C1100.14 1009.98 1559.32 893.468 1572.21 852.886C1585.1 812.305 1638.78 378.027 1480.87 274.568C1322.95 171.109 1205.68 235.113 969.47 307.825C733.259 380.537 589.572 385.696 437.256 257.279Z",
    fill: "url(#paint2_linear_98_4)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: 31,
    width: 1529,
    height: 412,
    fill: "url(#paint3_linear_98_4)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_98_4",
    x1: 565.854,
    y1: 1034.13,
    x2: 1038.85,
    y2: 180.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E06868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_98_4",
    x1: 535.071,
    y1: 1091.58,
    x2: 1008.06,
    y2: 237.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E06868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_98_4",
    x1: 563.071,
    y1: 1190.58,
    x2: 1036.06,
    y2: 336.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E06868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_98_4",
    x1: 704.41,
    y1: 417.25,
    x2: 706.931,
    y2: 196.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFooter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/footer.101afaa0.svg";
export { ForwardRef as ReactComponent };